import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import { RouteContext } from '@townsquare/router/routing-types';

export const ProjectsEmptyOrNonProvisionedState: ComponentType<RouteContext> &
	LoadableExport.LoadableComponent = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "ProjectsEmptyOrNonProvisionedState" */ './EmptyOrNonProvisionedState'
		),
	loading: () => null,
});
